module.exports = __webpack_public_path__ + "static/backgr2-73fd8cb965be0fb396ada57acf0bdb2d.png";